// extracted by mini-css-extract-plugin
export var equalColumn = "_hb-0";